import { getEachWayTitle } from "../getEachWayTitle";
import { EventsBySportIdRequest } from "sb-bff-integration";
export var getEventTitle = function (event, market, eachWayString) {
    if (event.type === EventsBySportIdRequest.EventTypesEnum.Outright.toString()) {
        var placeTerm = parseInt(market.metadata.placeTermsId);
        var oddsTerms = parseInt(market.metadata.oddsTermsId);
        var eachWay = oddsTerms && placeTerm
            ? getEachWayTitle(eachWayString, placeTerm, oddsTerms)
            : "";
        return event.eventName + " " + eachWay + " " + event.eventDate + " | " + event.eventTime;
    }
    return event.eventName;
};
//# sourceMappingURL=getEventTitle.js.map